import { useEffect, useState } from "react";

import type { IActivationAgentFormValue } from "app/pages/sales-intelligence/modules/onboarding/types/form-value";

export type OnboardingFormEditableItems = Pick<IActivationAgentFormValue, "targetCompanyTypes" | "targetPersonas">;

const formInitialValue: IActivationAgentFormValue = {
    targetPersonas: [],
    targetCompanyTypes: [],
    signals: [],
};

interface IResult {
    formValue: IActivationAgentFormValue;
    formItems: OnboardingFormEditableItems;
    handleSetFormValue: (newFormValue: Partial<IActivationAgentFormValue>) => void;
    handleSetFormItems: (newFormItems: Partial<OnboardingFormEditableItems>) => void;
}

function useOnboardingFormState(
    initialInfoData?: OnboardingInitData,
    signalsInfoData?: OnboardingSignalsInfoData,
): IResult {
    const [formValue, setFormValue] = useState<IActivationAgentFormValue>(formInitialValue);
    const [formItems, setFormItems] = useState<OnboardingFormEditableItems>(formInitialValue);

    const handleSetFormValue = (newFormValue: Partial<IActivationAgentFormValue>) =>
        setFormValue((prev) => ({
            ...prev,
            ...newFormValue,
        }));

    const handleSetFormItems = (newFormItems: Partial<OnboardingFormEditableItems>) =>
        setFormItems((prev) => ({
            ...prev,
            ...newFormItems,
        }));

    useEffect(() => {
        if (
            !initialInfoData ||
            !initialInfoData.options?.targetCompanyTypes ||
            !initialInfoData.options?.targetPersonaTitles
        ) {
            return;
        }

        setFormItems({
            targetPersonas: initialInfoData.options.targetPersonaTitles,
            targetCompanyTypes: initialInfoData.options.targetCompanyTypes,
        });
        handleSetFormValue({
            targetPersonas: initialInfoData.options.targetPersonaTitles.slice(0, 2),
            targetCompanyTypes: initialInfoData.user.companyTypesSelectionByIndustry,
        });
    }, [initialInfoData]);

    useEffect(() => {
        if (!signalsInfoData || !signalsInfoData.signals) {
            return;
        }

        handleSetFormValue({
            signals: signalsInfoData.signals.slice(0, 2),
        });
    }, [signalsInfoData]);

    return {
        formValue,
        formItems,
        handleSetFormValue,
        handleSetFormItems,
    };
}

export default useOnboardingFormState;
